import { useRef, useState } from 'react'

import uniteIcon from '../../imgs/pc-actions/unite-package-icon.svg'
import uniteDisabledIcon from '../../imgs/pc-actions/unite-package-icon-disabled.svg'
import Tooltip from '../Tooltip'

export const uniteButtonTexts = {
  default: 'איחוד חבילות',
  disabled: 'איחוד חבילות',
  cancel: 'ביטול איחוד',
  tooltipTitle: 'בקשה בטיפול',
  tooltipDescription: 'לא ניתן לשלוח בקשה לאיחוד כרגע',
}
export const UniteButton = ({ item, onUniteRequest, onCancelUniteRequest, texts = uniteButtonTexts }) => {
  const [visibleTooltip, setVisibleTooltip] = useState(false)
  const uniteIconRef = useRef(null)

  const createTooltipCloser = isOpen => {
    if (!isOpen) {
      setVisibleTooltip(false)
    }
  }
  // Disabled - other requests active
  if (item.isPaid || item.isShipped || item.isReturnRequestActive || item.isPhotoRequestActive || item.isShrinkRequestActive) {
    return (
      <>
        <button className='tool-cont' onClick={() => setVisibleTooltip(true)}>
          <div className='tool-cont-img-bcg' ref={uniteIconRef}>
            <img src={uniteDisabledIcon} alt='Unite packages disabled' />
          </div>
          <span>{texts.disabled}</span>
        </button>
        <Tooltip
          title={texts.tooltipTitle}
          description={texts.tooltipDescription}
          isTooltipOpen={visibleTooltip}
          setIsTooltipOpen={createTooltipCloser}
          triggerRef={uniteIconRef}
        />
      </>
    )
  }
  // Default - can request unite
  if (!item.isForUnite) {
    return (
      <button className='tool-cont' onClick={onUniteRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={uniteIcon} alt='Unite packages' />
        </div>
        <span>{texts.default}</span>
      </button>
    )
  }

  // Cancel unite request
  if (item.isForUnite) {
    return (
      <button className='tool-cont' onClick={onCancelUniteRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={uniteDisabledIcon} alt='Cancel unite' />
        </div>
        <span style={{ color: 'red' }}>{texts.cancel}</span>
      </button>
    )
  }

  return null
}
